/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useMemo} from 'react';

function CLIAuthPage() {

    const targetUrl = useMemo(() => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('menuItem', 'access');
        return `/settings?${searchParams.toString()}`;
    }, []);

    useEffect(() => {
        window.location.replace(targetUrl);
    }, [targetUrl]);

    return (
        <div className={"space-y-6 p-6 flex flex-col items-center justify-center"}>
            <p className="text-lg font-medium">Redirecting to settings...</p>
            <p className="text-sm text-gray-500">
                If you are not redirected automatically, <a
                href={targetUrl}
                className="text-blue-600"
            >
                please click.
            </a>
            </p>


        </div>
    );
}

CLIAuthPage.propTypes = {};

CLIAuthPage.defaultProps = {};


export default CLIAuthPage;